import { isEqual } from 'instantsearch.js/es/lib/utils';

function getStateWithoutPageAndUserToken(state) {
  // eslint-disable-next-line no-unused-vars
  const { page, userToken, ...rest } = state || {};
  return rest;
}

export function createInfiniteHitsSessionCache() {
  let lastWrittenPage = -1;
  let cachedHits;
  let cachedState;
  let KEY = 'cece.infinite-hits';
  return {
    read({ state }) {
      try {
        // Algolia/instantsearch is requesting a lower value than what
        // it has been written so far. We assume the app is navigating to
        // an earlier page, which means we want to reset the cache so that
        // it does't return any cached items from later pages
        if (state.page < lastWrittenPage) {
          this.clear();
          return null;
        }

        if (
          cachedState &&
          cachedHits &&
          isEqual(cachedState, getStateWithoutPageAndUserToken(state))
        ) {
          return cachedHits;
        }

        // Server-side, or no sessionStorage available
        if (typeof window === 'undefined' || !window.sessionStorage) {
          return null;
        }

        const cache = JSON.parse(sessionStorage.getItem(KEY));
        if (!cache) {
          return null;
        }
        if (!isEqual(cache.state, getStateWithoutPageAndUserToken(state))) {
          return null;
        }
        return cache.hits;
      } catch (error) {
        if (error instanceof SyntaxError) {
          try {
            sessionStorage.removeItem(KEY);
          } catch (err) {
            // do nothing
          }
        }
        return null;
      }
    },
    write({ state, hits }) {
      cachedState = getStateWithoutPageAndUserToken(state);
      cachedHits = hits;
      lastWrittenPage = state.page;

      // Server-side, or no sessionStorage available
      if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
      }

      try {
        sessionStorage.setItem(
          KEY,
          JSON.stringify({
            state: cachedState,
            hits,
          })
        );
      } catch (error) {
        // do nothing
      }
    },
    clear() {
      // Clear in-memory cache
      cachedHits = null;
      cachedState = null;
      lastWrittenPage = -1;

      if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
      }

      // Clear sessionStorage cache
      sessionStorage.removeItem(KEY);
    },
  };
}
